module.exports = __webpack_public_path__ + "static/media/JakeEmailButton.b2472796.png";